import type { PropsWithChildren, ReactNode } from 'react';

type Props = PropsWithChildren<{
    icon: ReactNode;
    title: ReactNode;
}>;
export default function SummaryItem({ icon, title, children }: Props) {
    return (
        <div className="flex flex-row gap-4">
            <div className="text-lg">{icon}</div>
            <div className="flex flex-col gap-3 text-sm">
                <div className="text-dark-green/50 text-xs font-bold uppercase">{title}</div>
                {children}
            </div>
        </div>
    );
}
